import { ActionMap } from "@context/types/index";
import { IOptions } from "@components/form/Select/interface";

export enum TypesPatient {
  Save = "SAVE_PATIENT",
  Reset = "RESET_PATIENT",
}

export interface IPatient {
  country: IOptions | "";
  state: IOptions | "";
  city: IOptions | "";
  address: string;
  streetName: IOptions | "";
  neighborhood: string;
  addressDetail: string;
  phone: string;
  email: string;
  means: IOptions | "";
  natural?: INaturalPerson;
  legal?: ILegalPerson;
}
export interface ILegalPerson {
  entity: string | number;
  entityType?: string;
}
export interface INaturalPerson {
  name: string;
  lastName: string;
  relationship: string;
  relationshipType: IOptions | "" | string;
  bond: IOptions | "";
  docType: IOptions | "";
  documemt: string;
}
export type PatientPayload = {
  [TypesPatient.Save]: IPatient;
  [TypesPatient.Reset]: undefined;
};

export type PatientActions = ActionMap<PatientPayload>[keyof ActionMap<PatientPayload>];
